export default __webpack_public_path__ + "static/banner-147b28949ea3ea8550a0c07ddf386180.jpg";